import moment from "moment";
import React from "react";
import {
  formatDate,
  formatDocument,
} from "../../../../../../../../utils/formatters";
import DetailsGrid from "../../details-grid";

const getPrioridade = ({ doenca, idoso, pcd }) => {
  const prioridades = [];

  if (doenca) {
    prioridades.push("Doença");
  }

  if (idoso) {
    prioridades.push("Idoso");
  }

  if (pcd) {
    prioridades.push("PcD");
  }

  return prioridades.join(", ");
};

const BasicData = ({ data, assertiva = {} }) => {
  const { pessoa } = data;
  const isCompany = (pessoa.cpfCnpj || assertiva.documento)?.length === 14;

  const columns = [
    {
      label: "Nome",
      field: "pessoa.nome",
    },
    {
      label: "Documento",
      field: "document",
      valueGetter: ({ pessoa, assertiva }) =>
        pessoa.cpfCnpj || assertiva.documento,
      valueFormatter: formatDocument,
    },
    {
      label: "OAB",
      field: "oab",
    },
    {
      label: `Data de ${isCompany ? "abertura" : "nascimento"}`,
      field: "dataNascimento",
      valueGetter: ({ pessoa, assertiva }) =>
        pessoa.dataNascimento || moment.utc(assertiva.dataNascimento),
      valueFormatter: formatDate,
    },
    {
      label: "Prioridade",
      field: "prioridade",
      valueGetter: getPrioridade,
    },
    {
      label: "CNAE",
      field: "assertiva.cnaeDescricao",
    },
    {
      label: "Porte",
      field: "assertiva.porteEmpresa",
    },
    {
      label: "Natureza jurídica",
      field: "assertiva.naturezaJuridica",
    },
    {
      label: "RG",
      field: "rg",
      valueGetter: ({ assertiva: { rg, ufRg } }) =>
        [rg, ufRg].filter((val) => val).join("/"),
    },
    {
      label: "Gênero",
      field: "assertiva.sexo",
    },
    {
      label: "Indícios de falecimento",
      field: "assertiva.obitoProvavel",
    },
  ];

  return (
    <DetailsGrid data={{ ...data, assertiva: assertiva }} columns={columns} />
  );
};

export default BasicData;
